var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "item banner banner-image",
        attrs: {
          id: "ctl00_mainContent_cppMiddle_lt_mainZone_Carousel_SlideTwo",
        },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "container banner-image_content" }, [
          _c("div", { staticClass: "content content-box left-content" }, [
            _c("p", {
              domProps: { innerHTML: _vm._s(this.labels.introSubHeading) },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn--chevron",
                on: { click: _vm.startQuoteTool },
              },
              [_vm._v(_vm._s(_vm.labels.introStartButton))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "middle-content-container" }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("section", { staticClass: "section-features" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "features col-sm-6" }, [
            _c("h2", { staticClass: "features__title" }, [
              _vm._v(_vm._s(_vm.labels.introWhyS4BHeading)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.labels.introWhyS4BText) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "features col-sm-6" }, [
            _c("h2", { staticClass: "features__title" }, [
              _vm._v(_vm._s(_vm.labels.introWhatInfoNeededHeading)),
            ]),
            _vm._v(" "),
            _vm._m(1),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          ref: "trustbox",
          staticClass: "trustpilot-widget",
          attrs: {
            "data-businessunit-id": "602cdbce6d4d040001b3b787",
            "data-locale": "en-GB",
            "data-review-languages": "en",
            "data-stars": "1,2,3,4,5",
            "data-style-height": "170px",
            "data-style-width": "100%",
            "data-template-id": "53aa8912dec7e10d38f59f36",
            "data-theme": "light",
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "https://uk.trustpilot.com/review/source4b.co.uk",
                rel: "noopener",
                target: "_blank",
              },
            },
            [_vm._v("Trustpilot")]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "notice" }, [
      _c("div", { staticClass: "container" }, [
        _c("h2", { staticClass: "notice__title text-center" }, [
          _vm._v(_vm._s(_vm.labels.introBeforeStartHeading)),
        ]),
        _vm._v(" "),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.labels.introBeforeStartText) },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", {
        staticClass: "alert-box--green",
        domProps: { innerHTML: _vm._s(_vm.labels.introReminderBox) },
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn--chevron", on: { click: _vm.startQuoteTool } },
        [_vm._v(_vm._s(_vm.labels.introStartButton))]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-image_container" }, [
      _c("div", { staticClass: "banner-image_container" }, [
        _c("img", {
          staticClass: "img-responsive banner-image",
          attrs: { src: "/dist/img/quote-tool-banner-background.jpg" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("ul", { staticClass: "tick-list" }, [
        _c("li", [
          _vm._v(
            "Your main business details such as contact information and billing address"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("The\n\t\t\t\t\t\t\t\t"),
          _c("div", { staticClass: "quote-popup quote-popup--inline" }, [
            _c("span", { staticClass: "quote-popup__toggle" }, [
              _vm._v("Supply Point IDs"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "quote-popup__modal" }, [
              _c("table", [
                _c("tbody", [
                  _c("tr", [
                    _c("td", [
                      _c("strong", [_vm._v("More about your SPID")]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            "Your SPID number may appear on the first or second page of your bill and comprises 12 digits and one letter"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "It will normally, but not always start with 301 or 302"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "You might have separate SPIDs for your water supply and wastewater. We only need one of these as they are interlinked"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("img", {
                        staticClass: "quote-popup__image",
                        attrs: { src: "/dist/img/spid-placeholder.jpg" },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(
            "\n\t\t\t\t\t\t\t\t(SPIDs) or property number(s) of all site(s) within your business. You can find these in the top right-hand corner of your bill\n\t\t\t\t\t\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "If you are an existing customer, the customer number(s) of all sites within your business. You'll also find these on your bill"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("An estimate of annual "),
          _c("strong", [_vm._v("water usage")]),
          _vm._v(" at each site(s) - we can estimate this using SPIDs"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Bank details - you'll need your account number & sort code if paying by Direct Debit - but you can also pay by BACS."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }